import React, { useState, useRef, MouseEvent } from 'react';
import { Fab, useTheme } from '@mui/material';
import { BiLogoWhatsapp } from 'react-icons/bi';
import { Link } from 'react-router-dom';
import { Format } from '../../utils';
import useAuth from '../../context/auth';

export const FloatingSupport = () => {
    const { isMobile } = useAuth()
    const [position, setPosition] = useState({ x: window.innerWidth - (isMobile ? 70 : 100), y: window.innerHeight - (isMobile ? 70 : 100) }); // posição inicial
    const dragging = useRef(false);
    const dragStart = useRef({ x: 0, y: 0 });
    const { palette } = useTheme()

    const handleMouseDown = (e: MouseEvent<HTMLButtonElement>) => {
        dragging.current = true;
        dragStart.current = { x: e.clientX - position.x, y: e.clientY - position.y };

        // Prevenir a navegação do link enquanto está arrastando
        e.preventDefault();
    };

    const handleMouseMove = (e: MouseEvent) => {
        if (dragging.current) {
            setPosition({
                x: e.clientX - dragStart.current.x,
                y: e.clientY - dragStart.current.y,
            });
        }
    };

    const handleMouseUp = () => {
        dragging.current = false;
    };

    // Adiciona eventos para mouse
    React.useEffect(() => {
        //@ts-ignore
        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);

        return () => {
            //@ts-ignore
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, []);

    return (
        <div>
            <Link
                to={`https://wa.me/+5555997181093?text=${Format.whatsAppMessage("Olá, gostaria de atendimento")}`}
                target="_blank"
                onClick={(e) => {
                    // Impede o clique no link enquanto o botão está sendo arrastado
                    if (dragging.current) {
                        e.preventDefault();
                    }
                }}
            >
                <div style={{
                    position: 'fixed',
                    left: `${position.x - 30}px`,
                    top: `${position.y - (isMobile ? 25 : 40)}px`, // Ajusta o texto para estar acima do botão
                    fontSize: isMobile ? "14px" : '18px',
                    color: palette.primary.main,
                    textAlign: 'center',
                    fontWeight: 700
                }}>
                    Atendimento
                </div>
                <Fab
                    color="primary"
                    aria-label="add"
                    onMouseDown={handleMouseDown}
                    size={isMobile ? "small" : "medium"}
                    style={{
                        position: 'fixed',
                        left: `${position.x}px`,
                        top: `${position.y}px`,
                    }}
                >
                    <BiLogoWhatsapp size={isMobile ? 30 : 40} />
                </Fab>
            </Link>
        </div>
    );
};

export default FloatingSupport;
